import { render, staticRenderFns } from "./asignarPermisos.vue?vue&type=template&id=5d1a8df5&scoped=true&"
import script from "./asignarPermisos.vue?vue&type=script&lang=js&"
export * from "./asignarPermisos.vue?vue&type=script&lang=js&"
import style0 from "./asignarPermisos.vue?vue&type=style&index=0&id=5d1a8df5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a8df5",
  null
  
)

export default component.exports